import { observable, computed } from 'mobx'
import { Countries, CANProvinces, CompaniesModels } from '@getgreenline/companies'

export class RegisterModel {
  @observable
  email = ''

  @observable
  companyName = ''

  @observable
  name = ''

  @observable
  password = ''

  @observable
  timezone?: string

  @observable
  province: CompaniesModels.Provinces = CANProvinces.AB

  @observable
  country: Countries = Countries.CAN
}
